module.exports = __webpack_public_path__ + "img/calendar_start.75399686.png";